import { render } from "./XIDButton.vue?vue&type=template&id=24dd12de&scoped=true&ts=true"
import script from "./XIDButton.vue?vue&type=script&lang=ts"
export * from "./XIDButton.vue?vue&type=script&lang=ts"

import "./XIDButton.vue?vue&type=style&index=0&id=24dd12de&scoped=true&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dd12de"]])

export default __exports__